import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HashRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier s'il y a un hash dans l'URL
    const hash = window.location.hash;
    
    if (hash && hash.startsWith('#/')) {
      // Extraire le chemin du hash (sans le #)
      const path = hash.substring(1);
      
      // Rediriger vers l'URL propre
      navigate(path, { replace: true });
    }
  }, [navigate]);

  return null; // Ce composant ne rend rien
};

export default HashRedirect;
